var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [_c("strong", { domProps: { textContent: _vm._s(_vm.type) } })]),
      _vm.showApexChart
        ? _c("apex-charts", { attrs: { data: _vm.detail, source: _vm.source } })
        : _c(_vm.type, {
            tag: "component",
            attrs: { data: _vm.detail, source: _vm.source },
          }),
      _c("hr"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }